import { CurrencyPipe } from '@angular/common';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MicroempresarioService } from '../../services/microempresario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { UserService } from '../../../services/user.service';
import { solicitudNatural } from '../../models/solicitud-natural';
import { ActivatedRoute } from '@angular/router';
import { BancoldexService } from '../../../comun/services/bancoldex.service';
import { redesSociales } from '../../models/redesSociales';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { Localidad } from 'src/app/comun/models/localidad';
import { LOCALIDADES_BOGOTA } from 'src/app/comun/data/localidades-bogota';

//jQuery
declare var $: any;
//Constantes
const ParametroEncaleDocumento = 'PAR-033';
const ParametroEdadMaximaSolCredito = 'PAR-055';
const ParametroMontoMaxCreditoExpress = 'PAR-068';
const ParametroMontoMinCreditoExpress = 'PAR-069';
const ParametroPlazoMaxCreditoExpress = 'PAR-071';
const ParametroPlazoMinCreditoExpress = 'PAR-074';
const ParametroFechaRegistroMinima = 'PAR-070';
const ParametroTextoMonto = 'PAR-072';
const ParametroTextoFecha = 'PAR-073';
const ParametroTextoPlazo = 'PAR-075';
const ParametroTextoFechaNacimiento = 'PAR-091';
const ParametroEncaleDocumentoSE = 'PAR-094';
const ParametroRedesSociales = 'PAR-095';
const ParametroSeccionFlujoCaja = 'PAR-128';

@Component({
    selector: 'solicitud-natural-form',
    templateUrl: './solicitud.natural.form.html',
    standalone: false
})
export class SolicitudNaturalForm implements OnInit {
  @Output() event = new EventEmitter<any>();
  isSave: boolean = false;
  idEstadoSolicitud: number;
  naturalForm: UntypedFormGroup;
  numSolicitud: string = '';
  titleModal: string = 'R';
  redesSociales : string[] = [];
  uno: number=1;
  cero: number=0;
  //Selects
  estadoCivil: any[] = [];
  nivelEstudio: any[] = [];
  tipoVivienda: any[] = [];
  departamentos: any[] = [];
  ciudades: any[] = [];
  anios: any[] = [];
  mensajeInformativo: String = null;
  fechaActual: String = new Date().toLocaleDateString('en-CA');
  fechaNacCorr:Date = new Date();
  fechaNacMin:Date = new Date();
  fechaCorrectaMinimaNacimiento: String = null;
  fechaCorrectaNacimiento: String = null;
  rutaAchivo: String = null;
  rutaAchivoExpress: String = null;
  observacionDevolucion: string = null;
  edadMaximaSolicitudCredito: any = null;
  montoMaximo: number = null;
  montoMaxExpress: number = null;
  montoMinExpress: number = null;
  fechaMinRegistro: number = null;
  plazoMaxExpress: number = null;
  plazoMinExpress: number = null;
  mensajeMonto: string = null;
  mensajeFechaRegistro: string = null;
  mensajeError: string = null;
  mensajeErrorFecha: string = null;
  mensajeErrorPlazo: string = null;
  plazoMinError: string = null;
  mensajeFechaNacimiento: string = null;
  mensajeRedesSociales:string = null;
  isSeccionFlujoCaja: boolean = false;
  isExpress:boolean = false;
  hasValidator:number=0;
  camposLlenados:number=0;
  porcentajeVertical: number = 0;
  datosFormulario: string = 'credito';
  datosCliente: string = 'DatosPersonales';
  sisben:any[]=[];
  errorMontoMax: boolean = false;
  errorPlazoMax: boolean = false;
  meses: string[] = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
  // Variables campos invalidos
  isCredito: boolean = true;
  isCliente: boolean = true;
  isNegocio: boolean = true;
  isResidencia: boolean = true;
  isFamiliares: boolean = true;
  isEconomicos: boolean = true;
  isFlujoCaja: boolean = true;
  isMobile: boolean = true;
  seccionCredito = ['monto', 'plazo', 'destino'];
  seccionCliente = {
    DatosPersonales: ['razonSocial','correoElectronico','fechaNacimiento','fechaExpedicionDocumento'],
    DatosResidencia: ['idDepartamento','idCiudad','idLocalidad','idTipoVivienda','barrioResidencia','direccionResidencia'],
    DatosFamiliares: ['idEstadoCivil','seguridadSocial','idNivelEstudios','personasACargo','sisben','idSisben'],
    DatosEconomicos: ['creditoAnterior','fechaCreditoAnterior','fechaRegistroActividadEconomica','anioActivos','nivelActivos'],
    DatosFlujoCaja: ['flujoCajaMesCorteInformacion','flujoCajaVentas']
  };
  invalidControls: any[] = [];
  invalidSeccion: any[] = [];
  isSolicitudAnterior: boolean = false;
  readonly idBogota = 11001;
  localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private _parametro: ParametrosService,
    private _user: UserService,
    private route: ActivatedRoute,
    private _microempresario: MicroempresarioService,
    public pipe: CurrencyPipe,
    private _bancoldexService: BancoldexService,
    private _sweetAlert: SweetAlertService,
  ) {
    window.scroll(0, 0);
    this.getMontoCreditoExpress();
    this.getPlazoCreditoExpress();
    this.getMensajeMonto();
    this.getMontoMaximo();
    this.getEdadMaximaSolicitudCredito();
    this.getFechaRegistroMinima();
    this.getMensajeRedesSociales();

    this.naturalForm = this.formBuilder.group({
      idEmpresario: [0],
      idEmpresarioNatural: [0],
      solicitud: this.formBuilder.group({
        idSolicitud: [null],
        monto: ['', Validators.required],
        plazo: ['', Validators.required],
        idUsuario_NeoUsuario: [0],
        destino: ['', Validators.required],
      }),
      razonSocial: [{ value: '', disabled: true }, Validators.required],
      correoElectronico: [{ value: '', disabled: true }, Validators.required],
      fechaNacimiento: ['', Validators.required],
      fechaExpedicionDocumento: ['', Validators.required],      
      idDepartamento: ['', [ Validators.required,Validators.min(1)]],
      idCiudad: ['', [ Validators.required,Validators.min(1)]],
      idLocalidad: [''],
      idTipoVivienda: [0, [ Validators.required,Validators.min(1)]],
      barrioResidencia: ['', Validators.required],
      direccionResidencia: ['', Validators.required],      
      idEstadoCivil: [0, [ Validators.required,Validators.min(1)]],
      seguridadSocial: ['', Validators.required],
      idNivelEstudios: [0, [ Validators.required,Validators.min(1)]],
      personasACargo: ['', Validators.required],
      sisben:['',Validators.required],
      idSisben:[''],
      creditoAnterior: ['', Validators.required],
      fechaCreditoAnterior: [''],
      fechaRegistroActividadEconomica: ['', Validators.required],
      anioActivos: [0, [ Validators.required,Validators.min(1)]],
      nivelActivos: ['', Validators.required],
      //Ingresos mensuales
      flujoCajaMesCorteInformacion: [''],
      flujoCajaVentas: [''],
      flujoCajaOtrosIngresos: [''],
      flujoCajaFuenteOtrosIngresos: [''],
      totalIngresos: [''],
      //Gastos mensuales
      flujoCajaPagoProveedores: [''],
      flujoCajaArriendo: [''],
      flujoCajaAdministracion: [''],
      flujoCajaServiciosPublicos: [''],
      flujoCajaSueldoPropio: [''],
      flujoCajaSueldoEmpleados: [''],
      flujoCajaPlanCelular: [''],
      flujoCajaTarjetaCredito: [''],
      flujoCajaCuotaCreditos: [''],
      flujoCajaSaldoDeudas: [''],
      flujoCajaOtrosGastos: [''],
      flujoCajaFuenteOtrosGastos: [''],
      totalGastos: [''],
      dineroDisponible: [''],
      centralRiesgo: [false, [Validators.required, Validators.requiredTrue]],      
      red: [''],
    });
    $(function () {
      $('[data-bs-toggle="tooltip"]').tooltip({
        boundary: "window",
        template:
          '<div class="tooltip tooltip-custom" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      });
    });
  }

  ngOnInit(): void {
    this.getEnlaceDocumento();
    this.getEnlaceDocumentoSolicitudExpress();
    this.getEstadoCivil();
    this.getNivelEstudio();
    this.getTipoVivienda();
    this.getDepartamentos();
    this.getAnios();
    this.loadData();
    this.formatPipe();
    this.getMensajeInformativo();
    this.getListaClasificacionSisben();
    this.getActivarSeccionFlujoCaja();
  }

  getMensajeInformativo() {
    this._microempresario
      .getMensajeInformativo(this._user.getUser().tipoPersona)
      .subscribe((response) => {
        if (response['exitoso'] == true) {
          this.mensajeInformativo = response['mensaje'];
        }
      });
  }

  //Métodos para cargar los selects//
  getEstadoCivil() {
    this._parametro
      .getEstadoCivil()
      .subscribe((data: any) => (this.estadoCivil = data));
  }

  getNivelEstudio() {
    this._parametro
      .getNivelEstudios()
      .subscribe((data: any) => (this.nivelEstudio = data));
  }

  getTipoVivienda() {
    this._parametro
      .getTipoVivienda()
      .subscribe((data: any) => (this.tipoVivienda = data));
  }

  getDepartamentos() {
    this._parametro
      .getDepartamentos('169')
      .subscribe((data: any) => (this.departamentos = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los departamentos');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getCambio(i){
    this.selectpikerChange('idDepartamento');
    this.naturalForm.get('idCiudad').setValue('');
    $('.selectpicker').selectpicker('refresh');
    if(i.target.value != 0){
      this.getCiudades(i.target.value, false);
    }else{
      $('#idCiudad').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    }
  }

  getCiudades(idDepartamento: number, validar: boolean) {
    this._parametro
      .getCiudades(idDepartamento.toString())
      .subscribe((data: any) => (this.ciudades = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
      },
      () => {
        setTimeout(() => {
            $('#idDepartamento').prop('disabled', validar);
            $('#idCiudad').prop('disabled', validar);
            $('#idLocalidad').prop('disabled', validar);
            $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getAnios() {
    this._parametro
      .getAnios('natural')
      .subscribe((data: any) => {
        this.anios = data.anios;
        this.anios = this.anios.filter(anio => anio != new Date().getFullYear()-2 &&  anio != new Date().getFullYear());
      });
  }

  getListaClasificacionSisben(){
    this._microempresario
    .getClasificacionSisben()
    .subscribe((data: any) => (this.sisben = data.data),
    (error) => {
      this._sweetAlert.errorModal("Error!",true,'Error al cargar los grupos de sisbén');
    },
    () => {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      },300);
    });
  }
  //Fin Cargar Selects//

  saveForm() {
    var fecha1 = new Date(this.naturalForm.get('fechaExpedicionDocumento').value);
    var fecha2 = new Date(this.naturalForm.get('fechaNacimiento').value);
    var fechaExpMinima = new Date(fecha2);
    var fecha3 = this.naturalForm.get('fechaRegistroActividadEconomica').value;
    var fechaRegistroMinima = new Date(fecha3);
    fechaExpMinima.setMonth(fechaExpMinima.getMonth()+(12*18));
    fechaRegistroMinima.setMonth(fechaRegistroMinima.getMonth()+this.fechaMinRegistro);
    this.validarGuardadoSolicitud(fecha1,fecha2,fecha3);
  }

  validarGuardadoSolicitud(fecha1:Date, fecha2:Date,fecha3:any){
    var fechaExpMinima = new Date(fecha2);
    var fechaRegistroMinima = new Date(fecha3);
    fechaExpMinima.setMonth(fechaExpMinima.getMonth()+(12*18));
    fechaRegistroMinima.setMonth(fechaRegistroMinima.getMonth()+this.fechaMinRegistro);
    // variables propias del Fomulario
    var fechaExpDoc =this.naturalForm.get('fechaExpedicionDocumento').value;
    var fechaNacimiento =this.naturalForm.get('fechaNacimiento').value;
    var fechaAE =this.naturalForm.get('fechaRegistroActividadEconomica').value;
    if(fechaExpDoc == '' && fechaNacimiento== ''){
      if(this.isSisben() && this.isCreditoAnterior()){
        this.callServiceSaveSolicitud();
      }else{
        this.naturalForm.markAllAsTouched()
      }
    }else{
      if ((fecha1 > fecha2) && (fecha2 <= this.fechaNacCorr) && (fecha2 >= this.fechaNacMin)
      && (fecha1 >= fechaExpMinima)) {
        if(fechaAE == ''){
          if(this.isSisben() && this.isCreditoAnterior()){
            this.callServiceSaveSolicitud();
          }else{
            this.naturalForm.markAllAsTouched()
          }
        }else{
          if(fechaRegistroMinima <= new Date()){
            if(this.isSisben() && this.isCreditoAnterior()){
              this.callServiceSaveSolicitud();
            }else{
              this.naturalForm.markAllAsTouched()
            }
          }else{
            this.isSave = false;
            this.naturalForm.get('fechaRegistroActividadEconomica').setErrors({ incorrect: true });
          }
        }
      }else{
        this.isSave = false;
      }
    }

    if (fecha1 < fecha2) {
      this._sweetAlert.errorModal("Error!",true,'La fecha de expedición del documento no puede ser menor a la fecha de nacimiento');
      this.naturalForm.get('fechaExpedicionDocumento').setErrors({ incorrect: true });
    } else if (fecha1 == fecha2) {
      this._sweetAlert.errorModal("Error!",true,'La fecha de expedición del documento no puede ser igual a la fecha de nacimiento');
      this.naturalForm.get('fechaExpedicionDocumento').setErrors({ incorrect: true });
    } else if (fecha1 < fechaExpMinima) {
      this._sweetAlert.errorModal("Error!",true,'La fecha de expedicion no es correcta');
      this.naturalForm.get('fechaExpedicionDocumento').setErrors({ incorrect: true });
    }
    if (fecha2 < this.fechaNacMin || fecha2 > this.fechaNacCorr) {
      this._sweetAlert.errorModal("Error!",true,'La fecha de nacimiento no es correcta');
      this.naturalForm.get('fechaNacimiento').setErrors({ incorrect: true });
    }
    if (fechaRegistroMinima > new Date()) {
      this.naturalForm.get('fechaRegistroActividadEconomica').setErrors({ incorrect: true });
      this._sweetAlert.errorModal("Error!",true,this.mensajeFechaRegistro);
    }
  }

  validarSisben(value:boolean){
    if(value==true){
      this.setearValidadoresForm('idSisben', [Validators.required]);
    }else{
      this.setearValidadoresForm('idSisben', null);
    }
  }

  validarCreditoAnterior(valor:boolean){
    if(valor==true){
      this.setearValidadoresForm('fechaCreditoAnterior', [Validators.required])
    }else{
      this.setearValidadoresForm('fechaCreditoAnterior', null)
    }
  }

  validarFlujoCaja(valor: boolean) {
    if (valor == false) {
      this.setearValidadoresForm('flujoCajaMesCorteInformacion', [Validators.required]);
      this.setearValidadoresForm('flujoCajaVentas', [Validators.required]);
    } else {
      this.setearValidadoresForm('flujoCajaMesCorteInformacion', null);
      this.setearValidadoresForm('flujoCajaVentas', null);
    }
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.naturalForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.naturalForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  getJson(form: solicitudNatural) {
    const json = form;
    json.idEmpresario = +this._user.getUser().idEmpresario;
    json.idEmpresarioNatural = +this._user.getUser().idEmpresarioNatural;
    json.idEstadoCivil = +json.idEstadoCivil;
    json.idNivelEstudios = +json.idNivelEstudios;
    json.idLocalidad = json.idLocalidad ? +json.idLocalidad : null;
    json.idCiudad = +json.idCiudad;
    json.idDepartamento = +json.idDepartamento;
    json.personasACargo = this.naturalForm.get('personasACargo').value==null?"":+this.naturalForm.get('personasACargo').value;
    json.solicitud.monto = this.naturalForm.get('solicitud').get('monto').value != null ? +this.naturalForm
      .get('solicitud').get('monto').value.replace(/[,]/g, ''):0;
    json.solicitud.idUsuario_NeoUsuario = +this._user.getUser().idUsuario;
    json.nivelActivos = this.naturalForm.get('nivelActivos').value!=null?
    +this.naturalForm.get('nivelActivos').value.replace(/[,]/g, ''):0;
    json.seguridadSocial = json.seguridadSocial;
    json.redesSociales = this.redesSociales;
    json.barrioResidencia = this.naturalForm.get('barrioResidencia').value;
    json.direccionResidencia = this.naturalForm.get('direccionResidencia').value;
    json.creditoAnterior = this.naturalForm.get('creditoAnterior').value;
    json.fechaCreditoAnterior = json.creditoAnterior==1?this.naturalForm.get('fechaCreditoAnterior').value:'';
    json.sisben = this.naturalForm.get('sisben').value;
    json.idSisben = json.sisben==true?+this.naturalForm.get('idSisben').value:null;
    json.camposLlenados = this.getCamposLlenados();
    json.camposObligatorios = this.getCamposObligatorios();
    json.flujoCajaVentas = this.naturalForm.get('flujoCajaVentas').value!=null?
    +this.naturalForm.get('flujoCajaVentas').value.replace(/[,]/g, ''):0;
    json.flujoCajaOtrosIngresos = this.naturalForm.get('flujoCajaOtrosIngresos').value!=null?
    +this.naturalForm.get('flujoCajaOtrosIngresos').value.replace(/[,]/g, ''):0;
    json.flujoCajaPagoProveedores = this.naturalForm.get('flujoCajaPagoProveedores').value!=null?
    +this.naturalForm.get('flujoCajaPagoProveedores').value.replace(/[,]/g, ''):0;
    json.flujoCajaArriendo = this.naturalForm.get('flujoCajaArriendo').value!=null?
    +this.naturalForm.get('flujoCajaArriendo').value.replace(/[,]/g, ''):0;
    json.flujoCajaAdministracion = this.naturalForm.get('flujoCajaAdministracion').value!=null?
    +this.naturalForm.get('flujoCajaAdministracion').value.replace(/[,]/g, ''):0;
    json.flujoCajaServiciosPublicos = this.naturalForm.get('flujoCajaServiciosPublicos').value!=null?
    +this.naturalForm.get('flujoCajaServiciosPublicos').value.replace(/[,]/g, ''):0;
    json.flujoCajaSueldoPropio = this.naturalForm.get('flujoCajaSueldoPropio').value!=null?
    +this.naturalForm.get('flujoCajaSueldoPropio').value.replace(/[,]/g, ''):0;
    json.flujoCajaSueldoEmpleados = this.naturalForm.get('flujoCajaSueldoEmpleados').value!=null?
    +this.naturalForm.get('flujoCajaSueldoEmpleados').value.replace(/[,]/g, ''):0;
    json.flujoCajaPlanCelular = this.naturalForm.get('flujoCajaPlanCelular').value!=null?
    +this.naturalForm.get('flujoCajaPlanCelular').value.replace(/[,]/g, ''):0;
    json.flujoCajaTarjetaCredito = this.naturalForm.get('flujoCajaTarjetaCredito').value!=null?
    +this.naturalForm.get('flujoCajaTarjetaCredito').value.replace(/[,]/g, ''):0;
    json.flujoCajaCuotaCreditos = this.naturalForm.get('flujoCajaCuotaCreditos').value!=null?
    +this.naturalForm.get('flujoCajaCuotaCreditos').value.replace(/[,]/g, ''):0;
    json.flujoCajaSaldoDeudas = this.naturalForm.get('flujoCajaSaldoDeudas').value!=null?
    +this.naturalForm.get('flujoCajaSaldoDeudas').value.replace(/[,]/g, ''):0;
    json.flujoCajaOtrosGastos = this.naturalForm.get('flujoCajaOtrosGastos').value!=null?
    +this.naturalForm.get('flujoCajaOtrosGastos').value.replace(/[,]/g, ''):0;
    return json;
  }

  callServiceSaveSolicitud(){
    var body = this.getJson(this.naturalForm.value)
    this._microempresario
      .saveSolicitud('natural', body)
      .subscribe((data: any) => {
        if (data.exitoso) {
          this.naturalForm.get('solicitud').get('idSolicitud').setValue(data.idSolicitudCredito);
          this._user.setIdSolicitud(data.idSolicitudCredito);
          if(this.naturalForm.invalid){
            this.isSave = false;
            this.naturalForm.markAllAsTouched();
            this._sweetAlert.infoModal("¡Solicitud en borrador!",false,
            'Tu solicitud ha sido guardada exitosamente. Diligencia correctamente los campos obligatorios antes de continuar con el cargue de documentos.'
            ).then((result) => {
              if (result.isConfirmed) {
                setTimeout(() => {
                  this.scrollToFirstError();
                }, 300);
              }
            });
          }else{
            this.isSave = true;
            this._sweetAlert.successModal("¡Éxito!",false,"Da clic en el botón “siguiente” para continuar con el cargue de documentos.").then((result) => {
              if (result.isConfirmed) {
                setTimeout(() => {
                  this.scrollToFirstError();
                }, 300);
              }
            });
          }
        } else {
          this._sweetAlert.errorModal("Error!",true,data.error);
        }
      });
      this.camposLlenados = 0;
      this.hasValidator =0;
  }

  goFiles() {
    let evento = { tipo: '', estado: this.idEstadoSolicitud ? this.idEstadoSolicitud : 1 };
    if (this.isExpress) {
      evento.tipo = 'express';
      this.event.emit(evento);
    } else {
      evento.tipo = 'save'
      this.event.emit(evento);
    }
  }

  addRed(){
    let red: any;
    if((this.naturalForm.get('red').value).includes('https://')){
      red = `${this.naturalForm.get('red').value}`.toLowerCase();
    }else{
        red = `https://${this.naturalForm.get('red').value}`.toLowerCase();
    }
    if(this.redesSociales.indexOf(red) === -1){
      this.redesSociales.push(red);
      this.naturalForm.get('red').setValue("");
    }
  }

  deleteRed(index : number){
    this.redesSociales.splice(index, 1);
  }

  loadData() {
    const idSolicitud = !this.route.snapshot.params.id
      ? null
      : this.route.snapshot.params.id;
    this._microempresario
      .cargarDatos({
        idEmpresario: +this._user.getUser().idEmpresario,
        idSolicitud: idSolicitud,
      })
      .subscribe((data: any) => {
        if (!data.solicitud) {
          const micro = data.Empresario;
          this.naturalForm.get('razonSocial').setValue(micro.razonSocial);
          this.naturalForm
            .get('correoElectronico')
            .setValue(micro.correoElectronico);
          if(micro.idDepartamento != null){
            this.naturalForm.get('idDepartamento').setValue(micro.idDepartamento);
            this.getCiudades(micro.idDepartamento, true);
            this.naturalForm.get('idCiudad').setValue(micro.idCiudad);
            this.naturalForm.get('idLocalidad').setValue(micro.idLocalidad);
            $('#idDepartamento').selectpicker('refresh');
            $('#idCiudad').selectpicker('refresh');
            $('#idLocalidad').selectpicker('refresh');
          }else{
            this.naturalForm.controls.idDepartamento.enable();
            this.naturalForm.controls.idCiudad.enable();
            this.naturalForm.controls.idLocalidad.enable();
            $('.selectpicker').selectpicker('refresh');
          }
          if(micro.fechaExpedicionDocumento){
            this.naturalForm
                .get('fechaExpedicionDocumento')
                .setValue(
                  new Date(micro.fechaExpedicionDocumento).toISOString().slice(0, 10)
                );
          }
          if(micro.fechaExpedicionDocumento){
            this.naturalForm
                .get('fechaNacimiento')
                .setValue(new Date(micro.fechaNacimiento).toISOString().slice(0, 10));
          }
        } else {
          this.isSolicitudAnterior = [1,5].includes(data.solicitud.idEstadoSolicitud_NeoEstadoSolicitud);
          this.loadSolicitud(data.solicitud);
          this.loadEmpresario(data.Empresario, data.solicitud);
          this.loadRedesSociales(data.RedesSociales);
        }
        if (data.observacionDevolucion) {
          this.observacionDevolucion = data.observacionDevolucion;
        }
        if (this.naturalForm.valid){
          this.isSave = true
        }
        this.calculoPorcentajeVertical();
      });
  }

  loadSolicitud(data: any) {
    this.idEstadoSolicitud = data.idEstadoSolicitud_NeoEstadoSolicitud;
    if(this.isSolicitudAnterior){
      this.naturalForm.get('solicitud').get('idSolicitud').setValue(data.idSolicitud);
      this._user.setIdSolicitud(data.idSolicitud);
      this.naturalForm.get('centralRiesgo').setValue(true);
    }
    this.naturalForm.get('solicitud').get('monto').setValue(data.monto);
    this.naturalForm.get('solicitud').get('plazo').setValue(data.plazo);
    this.naturalForm.get('solicitud').get('destino').setValue(data.destino);    
    this.naturalForm.get('solicitud').get('idUsuario_NeoUsuario').setValue(data.idUsuario_NeoUsuario);
  }

  loadEmpresario(data: any, solicitud: any) {
    let contador:number=0;
    const user = this._user.getUser();
    this.naturalForm.get('razonSocial').setValue(data.razonSocial);
    this.naturalForm.get('correoElectronico').setValue(data.correoElectronico);
    this.naturalForm.get('idEmpresario').setValue(data.idEmpresario);
    this.naturalForm
      .get('idEmpresarioNatural')
      .setValue(user.idEmpresarioNatural);
    this.naturalForm
      .get('fechaExpedicionDocumento')
      .setValue(
        new Date(data.fechaExpedicionDocumento).toISOString().slice(0, 10)
      );
    if (data.fechaRegistroActividadEconomica != null) {
      this.naturalForm
        .get('fechaRegistroActividadEconomica')
        .setValue(
          new Date(data.fechaRegistroActividadEconomica)
            .toISOString()
            .slice(0, 10)
        );
    }
    this.naturalForm
      .get('fechaNacimiento')
      .setValue(new Date(data.fechaNacimiento).toISOString().slice(0, 10));
    if (data.idDepartamento != null && data.idDepartamento != 0) {
      this.naturalForm.get('idDepartamento').setValue(data.idDepartamento);
      $('#idDepartamento').selectpicker('val', Number(data.idDepartamento));
      this.getCiudades(data.idDepartamento, true);
      this.naturalForm.get('idCiudad').setValue(data.idCiudad);
      $('#idCiudad').selectpicker('val', Number(data.idCiudad));
      this.naturalForm.get('idLocalidad').setValue(data.idLocalidad);
      $('#idLocalidad').selectpicker('val', Number(data.idLocalidad));
      $('.selectpicker').selectpicker('refresh');
    }else{
      this.naturalForm.controls.idDepartamento.enable();
      this.naturalForm.controls.idCiudad.enable();
      this.naturalForm.controls.idLocalidad.enable();
      $('.selectpicker').selectpicker('refresh');
    }
    this.naturalForm.get('barrioResidencia').setValue(data.barrioResidencia);
    this.naturalForm.get('direccionResidencia').setValue(data.direccionResidencia);
    this.naturalForm.get('idEstadoCivil').setValue(data.idEstadoCivil);
    this.naturalForm.get('idNivelEstudios').setValue(data.idNivelEstudios);    
    this.anios.forEach((elemento:any)=>{
      if(elemento != Number(data.anioActivos)){
        contador++
      }
    })
    if(contador>0){
      if(Number(data.anioActivos)!=0){
        this.anios.push(Number(data.anioActivos))
      }
    }
    if (this.isSolicitudAnterior) {
      this.naturalForm.get('anioActivos').patchValue(Number(data.anioActivos));
      this.naturalForm.get('nivelActivos').setValue(data.nivelActivos);;
    }    
    this.naturalForm.get('idTipoVivienda').setValue(data.idTipoVivienda);
    this.naturalForm.get('seguridadSocial').setValue(data.seguridadSocial);
    this.naturalForm.get('personasACargo').setValue(data.personasACargo);
    this.naturalForm.get('creditoAnterior').setValue(data.creditoAnterior);
    this.naturalForm.get('flujoCajaMesCorteInformacion').setValue(data.flujoCajaMesCorteInformacion);
    this.naturalForm.get('flujoCajaVentas').setValue(data.flujoCajaVentas);
    this.naturalForm.get('flujoCajaOtrosIngresos').setValue(data.flujoCajaOtrosIngresos);
    this.naturalForm.get('flujoCajaFuenteOtrosIngresos').setValue(data.flujoCajaFuenteOtrosIngresos);
    this.naturalForm.get('totalIngresos').setValue(data.flujoCajaTotalIngresos);
    this.naturalForm.get('flujoCajaPagoProveedores').setValue(data.flujoCajaPagoProveedores);
    this.naturalForm.get('flujoCajaArriendo').setValue(data.flujoCajaArriendo);
    this.naturalForm.get('flujoCajaAdministracion').setValue(data.flujoCajaAdministracion);
    this.naturalForm.get('flujoCajaServiciosPublicos').setValue(data.flujoCajaServiciosPublicos);
    this.naturalForm.get('flujoCajaSueldoPropio').setValue(data.flujoCajaSueldoPropio);
    this.naturalForm.get('flujoCajaSueldoEmpleados').setValue(data.flujoCajaSueldoEmpleados);
    this.naturalForm.get('flujoCajaPlanCelular').setValue(data.flujoCajaPlanCelular);
    this.naturalForm.get('flujoCajaTarjetaCredito').setValue(data.flujoCajaTarjetaCredito);
    this.naturalForm.get('flujoCajaCuotaCreditos').setValue(data.flujoCajaCuotaCreditos);
    this.naturalForm.get('flujoCajaSaldoDeudas').setValue(data.flujoCajaSaldoDeudas);
    this.naturalForm.get('flujoCajaOtrosGastos').setValue(data.flujoCajaOtrosGastos);
    this.naturalForm.get('flujoCajaFuenteOtrosGastos').setValue(data.flujoCajaFuenteOtrosGastos);
    this.naturalForm.get('totalGastos').setValue(data.flujoCajaTotalGastos);
    this.naturalForm.get('dineroDisponible').setValue(data.flujoCajaEfectivoDisponible);
    this.validarMonto();
    this.validarPlazo();
    if(data.sisben){
      this.naturalForm.get('sisben').setValue(data.sisben);
      this.naturalForm.get('idSisben').setValue(data.idSisben);
    }else{
      this.naturalForm.get('sisben').setValue(data.sisben);
    }
    if (!this.isSolicitudAnterior && solicitud.fechaDesembolso && data.creditoAnterior == 1) {
      this.naturalForm.get('fechaCreditoAnterior').setValue(new Date(solicitud.fechaDesembolso).toISOString().slice(0, 10));
      this.setearValidadoresForm('fechaCreditoAnterior', [Validators.required]);
    } else if(data.creditoAnterior == 1){
      this.naturalForm.get('fechaCreditoAnterior').setValue(new Date(data.fechaCreditoAnterior).toISOString().slice(0, 10));
      this.setearValidadoresForm('fechaCreditoAnterior', [Validators.required]);
    } else {
      this.naturalForm.get('fechaCreditoAnterior').setValue('');
      this.setearValidadoresForm('fechaCreditoAnterior', null);
    }
    this.naturalForm.markAllAsTouched();
  }

  loadRedesSociales(redesSociales : redesSociales[]){
    redesSociales.forEach(redSocial => this.redesSociales.push(redSocial.url));
  }

  validateRed(key: string){
    const red = `https://${this.naturalForm.get(key).value}`.toLowerCase();
    if(this.redesSociales.indexOf(red) !== -1){
      return true;
    }
  }

  validateField(key: string, item: string) {
    if (key === '') {
      return (
        this.naturalForm.get(item).dirty && this.naturalForm.get(item).invalid
      );
    } else {
      return (
        this.naturalForm.get(key).get(item).dirty &&
        this.naturalForm.get(key).get(item).invalid
      );
    }
  }
  validateCampo(key: string) {
    return (
      (this.naturalForm.get(key).dirty || this.naturalForm.get(key)?.touched) &&
      this.naturalForm.get(key)?.invalid
    );
  }

  //Validaciones Form

  validateLetters(event: any) {
    const pattern = /[a-zA-Z áéíóúÁÉÍÓÚñÑ@&._$-]+/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  cambiarPlazo() {
    if (this.naturalForm.get('solicitud.monto').value !== null && (Number(this.naturalForm.get('solicitud.monto').value.replaceAll(',', '') <= this.montoMaxExpress)
      && Number(this.naturalForm.get('solicitud.plazo').value > this.plazoMaxExpress))) {
      this.naturalForm.get('solicitud').get('plazo').setValue('');
    }    
  }

  validateNumberMonto(event: any) {
    let montoMaximo = this.pipe.transform(this.montoMaximo, 'USD', 'symbol', '0.0-0');
    const pattern2 = /[0]/;
    let inputChar = String.fromCharCode(event.charCode);
    let stringMontoMax = this.montoMaximo.toString();
    const patterMax = +stringMontoMax.substring(0, stringMontoMax.length - 1);
    if (this.naturalForm.get('solicitud.monto').value != null) { 
       if ((Number(this.naturalForm.get('solicitud.monto').value.replaceAll(',', '') == patterMax) &&
        !pattern2.test(inputChar)) || (Number(this.naturalForm.get('solicitud.monto').value.replaceAll(',', '') > patterMax))) {
        event.preventDefault();
        this.mensajeError = "El monto máximo es de " + montoMaximo + " pesos.";
        this.errorMontoMax = true;
      } else {
        this.errorMontoMax = false;
      }
    }
  }

  validateNumberPlazo(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    const pattern2 = /[0]/;
    let stringExpress = this.plazoMaxExpress.toString();
    const mExpress = +stringExpress.substring(0, stringExpress.length - 1);
    const patterEnd = stringExpress[stringExpress.length - 1];
    const pattern3 = new RegExp(`[0-${patterEnd}]`);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    } else if (this.naturalForm.get('solicitud.monto').value !== null &&
      (Number(
        this.naturalForm.get('solicitud.monto').value.replaceAll(',', '') <=
          this.montoMaxExpress
        ) &&
          Number(this.naturalForm.get('solicitud.plazo').value) < 100 &&
          Number(this.naturalForm.get('solicitud.plazo').value) == mExpress &&
          !pattern3.test(inputChar)) || (this.naturalForm.get('solicitud.monto').value !== null &&
        (Number(
          this.naturalForm.get('solicitud.monto').value.replaceAll(',', '') <=
          this.montoMaxExpress
        ) &&
          Number(this.naturalForm.get('solicitud.plazo').value) > mExpress &&
          pattern.test(inputChar)))
      ) {
        event.preventDefault();
    } else if (
      (Number(this.naturalForm.get('solicitud.plazo').value) < 100 &&
        Number(this.naturalForm.get('solicitud.plazo').value) == 18 &&
        !pattern2.test(inputChar)) ||
      (Number(this.naturalForm.get('solicitud.plazo').value) > 18 &&
        pattern.test(inputChar))
    ) {
      event.preventDefault();
      this.plazoMinError = "El plazo máximo permitido es de 180 meses.";
      this.errorPlazoMax = true;
    } else {
      this.errorPlazoMax = false;
    }
  }

  showModal(title: string) {
    this.titleModal = title;
    // $('#politicasModal').modal('show');
  }

  formatPipe(){
    this.setPipeForm('nivelActivos');    
    this.setPipeForm('solicitud.monto');
    this.setPipeForm('flujoCajaVentas');
    this.setPipeForm('flujoCajaOtrosIngresos');
    this.setPipeForm('totalIngresos');
    this.setPipeForm('flujoCajaPagoProveedores');
    this.setPipeForm('flujoCajaArriendo');
    this.setPipeForm('flujoCajaAdministracion');
    this.setPipeForm('flujoCajaServiciosPublicos');
    this.setPipeForm('flujoCajaSueldoPropio');
    this.setPipeForm('flujoCajaSueldoEmpleados');
    this.setPipeForm('flujoCajaPlanCelular');
    this.setPipeForm('flujoCajaTarjetaCredito');
    this.setPipeForm('flujoCajaCuotaCreditos');
    this.setPipeForm('flujoCajaSaldoDeudas');
    this.setPipeForm('flujoCajaOtrosGastos');
    this.setPipeForm('totalGastos');
    this.setPipeForm('totalGastos');
    this.setPipeForm('dineroDisponible');
  }

  setPipeForm(controlName: string) {
    let permitir: boolean = false;
    if(controlName == "dineroDisponible"){
      permitir = true;
    }
    const control = this.naturalForm.get(controlName);
    if (control) {      
      control.valueChanges.subscribe(value => {
        if (value !== null && value !== '') {
          const nuevoValor = this.cambiarFormatoNumero(value, permitir);
          control.patchValue(nuevoValor, { emitEvent: false });
        }
      });
    }     
  }

  cambiarFormatoNumero(value: any, permitir: boolean): string {
    let stringValue = String(value).replace(permitir ? /[^\d-]/g : /[^\d]/g, '');
    stringValue = stringValue.replace(/^0+/, '');
    const parts = stringValue.split(',');
    parts[0] = this.formatThousandsSeparator(parts[0], ',');
    return parts.join(',');
  }

  /** Formato miles sin regex vulnerable (evita ReDoS). */
  private formatThousandsSeparator(s: string, sep: string): string {
    if (!s) return s;
    let out = '';
    for (let i = 0; i < s.length; i++) {
      if (i > 0 && (s.length - i) % 3 === 0) out += sep;
      out += s[i];
    }
    return out;
  }

  getEnlaceDocumento() {
    var json = {
      idParametro: ParametroEncaleDocumento,
      nombre: null,
      isParFuncional: false,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.rutaAchivo = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );
  }

  getEnlaceDocumentoSolicitudExpress() {
    var json = {
      idParametro: ParametroEncaleDocumentoSE,
      nombre: null,
      isParFuncional: false,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.rutaAchivoExpress = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );
  }

  validateForm() {
    this.saveForm();
    this.naturalForm.markAllAsTouched();
    this.selectpikerChange('idDepartamento');
    this.selectpikerChange('idCiudad');
    this.selectpikerChange('idLocalidad');
    $("select").dropdown();
  }

  //Función para encontrar el campo siguiente en el formulario movil
  nextFieldMobile(field: string){
    const mobileContainer = document.querySelector('.d-block.d-xl-none');
    const element = mobileContainer.querySelector(`[formControlName="${field}"]`);
    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      (element as HTMLElement).focus();
    }, 100);
  }

  // Función para encontrar el primer campo inválido y desplazar la pantalla hacia él
  scrollToFirstError(): void {
    this.invalidControls = [];
    this.invalidSeccion = [];
    let timer = 0;
    this.findInvalidControl(this.naturalForm);
    if (this.invalidControls.length === 0) {
      this.isCredito = this.isCliente = this.isNegocio = this.isResidencia = this.isFamiliares = this.isEconomicos = this.isFlujoCaja = true;
    } else {
      const firstInvalidControl = this.invalidControls[0].name;
      if (firstInvalidControl) {
        const mobileContainer = document.querySelector('.d-block.d-xl-none');
        const desktopContainer = document.querySelector('.d-none.d-xl-block');
        // Verifica cuál de los contenedores es visible
        const visibleContainer = this.isVisible(mobileContainer) ? mobileContainer : desktopContainer;
        if (visibleContainer == mobileContainer) {
          if (this.isSeccionFlujoCaja || !this.isExpress) {
            this.seccionCliente.DatosEconomicos = this.seccionCliente.DatosEconomicos.filter((item) => item !== 'centralRiesgo');
            !this.seccionCliente.DatosFlujoCaja.includes('centralRiesgo') ? this.seccionCliente.DatosFlujoCaja.push('centralRiesgo') : '';
          } else {
            this.seccionCliente.DatosFlujoCaja = this.seccionCliente.DatosFlujoCaja.filter((item) => item !== 'centralRiesgo');
            !this.seccionCliente.DatosEconomicos.includes('centralRiesgo') ? this.seccionCliente.DatosEconomicos.push('centralRiesgo') : '';
          }
          this.findSeccion(this.invalidControls);
          this.datosFormulario = this.invalidSeccion[0].split('.')[0];
          this.datosCliente = this.invalidSeccion[0].split('.')[1] ? this.invalidSeccion[0].split('.')[1] : 'DatosPersonales';
          this.isCredito = this.invalidSeccion.includes('credito') ? false : true;
          this.isCliente = this.invalidSeccion.some(seccion => seccion.startsWith('cliente')) ? false : true;
          this.isNegocio = this.invalidSeccion.includes('cliente.DatosPersonales') ? false : true;
          this.isResidencia = this.invalidSeccion.includes('cliente.DatosResidencia') ? false : true;
          this.isFamiliares = this.invalidSeccion.includes('cliente.DatosFamiliares') ? false : true;
          this.isEconomicos = this.invalidSeccion.includes('cliente.DatosEconomicos') ? false : true;
          this.isFlujoCaja = this.invalidSeccion.includes('cliente.DatosFlujoCaja') ? false : true;
          timer = 600;
        }
        if (visibleContainer) {
          // Busca el primer campo inválido dentro del contenedor visible
          const invalidControlElement = visibleContainer.querySelector(`[formControlName="${firstInvalidControl}"]`);
          if (invalidControlElement) {
            setTimeout(() => {
              // Desplaza la pantalla hacia el campo inválido
              invalidControlElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              (invalidControlElement as HTMLElement).focus();
            }, timer);
          }
        }
      }
    }
  }

  // Función para verificar si la pantalla visible es movil
  isVisible(element: Element | null): boolean {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  // Funcion para buscas los campos invaliddos en el formulario
  findInvalidControl(formGroup: UntypedFormGroup) {
    for (const controlName of Object.keys(formGroup.controls)) {
      const control = formGroup.get(controlName);
      if (control instanceof UntypedFormGroup) {
        // Si el control es un FormGroup, buscar recursivamente
        this.findInvalidControl(control);
      } else if (control?.invalid) {
        this.invalidControls.push({ name: controlName });
      }
    }
  }

  // Funcion para buscar las secciones de los campos invalidos
  findSeccion(controls: { name: string }[]) {
    const secciones = {
      credito: this.seccionCredito,
      cliente: this.seccionCliente
    };
    for (const control of controls) {
      const controlName = control.name;
      for (const [seccionPrincipal, valores] of Object.entries(secciones)) {
        if (Array.isArray(valores)) {
          // Si los valores son un array
          if (valores.includes(controlName)) {
            if (!this.invalidSeccion.includes(seccionPrincipal)) {
              this.invalidSeccion.push(seccionPrincipal);
            }
          }
        } else if (typeof valores === 'object') {
          // Si los valores son un objeto
          for (const [subSeccion, subValores] of Object.entries(valores)) {
            if (Array.isArray(subValores) && subValores.includes(controlName)) {
              const fullPath = `${seccionPrincipal}.${subSeccion}`;
              if (!this.invalidSeccion.includes(fullPath)) {
                this.invalidSeccion.push(fullPath);
              }
            }
          }
        }
      }
    }
  }

  isSisben():boolean{
    var sisben =  this.naturalForm.get('sisben').value;
    if(sisben == ''){
      return true;
    }else{
      if(sisben == true && 
      (this.naturalForm.get('idSisben').value !=0 &&
      this.naturalForm.get('idSisben').value !=null)){
        return true;
      }if(sisben == false){
        this.naturalForm.get('idSisben').setValue('');
        return true;
      }else{
        return false;
      }
    }
  }

  isCreditoAnterior():boolean{
    var creditoAnterior =  this.naturalForm.get('creditoAnterior').value;
    var fechaCreditoAnterior = this.naturalForm.get('fechaCreditoAnterior').value;
    if(creditoAnterior == '' || creditoAnterior == null){
      return true;
    }else{
      if(creditoAnterior == 1 && 
      (fechaCreditoAnterior != null &&
        fechaCreditoAnterior != '')){
        return true;
      }if(creditoAnterior == 0){
        this.naturalForm.get('fechaCreditoAnterior').setValue('');
        return true;
      }else{
        this.naturalForm.get('fechaCreditoAnterior').setErrors({ incorrect: true });
        return false;
      }
    }
  }

  cambioForm(){
    this.isSave = false;
    this.calculoPorcentajeVertical();
  }

  getEdadMaximaSolicitudCredito() {
    var json = {
      idParametro: ParametroEdadMaximaSolCredito,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.edadMaximaSolicitudCredito = Number(respuesta[0].valorParametro);
        //fecha maxima de nacimiento
        this.fechaNacCorr.setMonth(this.fechaNacCorr.getMonth()-(12*18));
        //fecha minima de nacimiento
        this.fechaNacMin.setMonth(this.fechaNacMin.getMonth()-(12*(this.edadMaximaSolicitudCredito)));
      },
      (error) => {
      }
    );
    var json = {
      idParametro: ParametroTextoFechaNacimiento,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeFechaNacimiento = respuesta[0].valorParametro;
        this.mensajeFechaNacimiento +=' '+Number(this.edadMaximaSolicitudCredito);
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getMontoMaximo() {
    var json = {
      idParametro: 'PAR-057',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.montoMaximo = Number(respuesta[0].valorParametro);
        this.validarMonto();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getMontoCreditoExpress() {
    var json = {
      idParametro: ParametroMontoMaxCreditoExpress,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.montoMaxExpress = Number(respuesta[0].valorParametro);
        this.validarMonto();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
    var json = {
      idParametro: ParametroMontoMinCreditoExpress,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.montoMinExpress = Number(respuesta[0].valorParametro);
        this.validarMonto();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getPlazoCreditoExpress() {
    var json = {
      idParametro: ParametroPlazoMaxCreditoExpress,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.plazoMaxExpress = Number(respuesta[0].valorParametro);
        this.validarPlazo();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
    var json = {
      idParametro: ParametroPlazoMinCreditoExpress,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.plazoMinExpress = Number(respuesta[0].valorParametro);
        this.validarPlazo();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
    var json = {
      idParametro: ParametroTextoPlazo,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeErrorPlazo = respuesta[0].valorParametro;
        this.validarPlazo();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getFechaRegistroMinima() {
    var json = {
      idParametro: ParametroFechaRegistroMinima,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.fechaMinRegistro = Number(respuesta[0].valorParametro);
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
    var json = {
      idParametro: ParametroTextoFecha,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeFechaRegistro = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getMensajeMonto() {
    var json = {
      idParametro: ParametroTextoMonto,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeMonto = respuesta[0].valorParametro;
        this.validarMonto();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getMensajeRedesSociales(){
    var json = {
      idParametro: ParametroRedesSociales,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeRedesSociales = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal(error.error,true);
      }
    );
  }

  getActivarSeccionFlujoCaja() {
    var json = {
      idParametro: ParametroSeccionFlujoCaja,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.isSeccionFlujoCaja = JSON.parse(respuesta[0].valorParametro.toLowerCase());
      },
      (error) => {
        this._sweetAlert.errorModal(error.error, true);
      }
    );
  }

  validarPlazo(event?: any){
    if(event?.code == 'Backspace'){
      this.errorPlazoMax = false;
    }
    let auxMonto: number = this.naturalForm.get('solicitud').get('monto').value != null ?
    Number(this.naturalForm.get('solicitud').get('monto').value.replaceAll(',', '')) : 0;
    if(this.naturalForm.get('solicitud').get('plazo').value){
      if(Number(this.naturalForm.get('solicitud').get('plazo').value) < this.plazoMinExpress){
        this.naturalForm.get('solicitud').get('plazo').setErrors({ incorrect: true });
        this.plazoMinError = "El plazo mínimo permitido es de " + this.plazoMinExpress + " meses.";
        this.errorPlazoMax = false;
      }
      if( auxMonto >= this.montoMinExpress && auxMonto <= this.montoMaxExpress
        && Number(this.naturalForm.get('solicitud.plazo').value) <= this.plazoMaxExpress){
       this.isExpress = true;
     }else{
       this.isExpress = false;
     }
     this.validarFlujoCaja(this.isExpress);
     if(this.isSeccionFlujoCaja){
       this.validarFlujoCaja(!this.isSeccionFlujoCaja);
     }
    } else {
      this.errorPlazoMax = false;
      this.plazoMinError = "Campo obligatorio";
    }
  }

  validarMonto(event?: any) {
    if(event?.code == 'Backspace'){
      this.errorMontoMax = false;
    }
    let montoMinimo = this.pipe.transform(this.montoMinExpress, 'USD', 'symbol', '0.0-0');
    let montoMaximo = this.pipe.transform(this.montoMaximo, 'USD', 'symbol', '0.0-0');
    let auxMonto: number = this.naturalForm.get('solicitud').get('monto').value != null ?
    Number(this.naturalForm.get('solicitud').get('monto').value.replaceAll(',', '')) : 0;
    if (this.naturalForm.get('solicitud').get('monto').value) {
      if (Number(this.naturalForm.get('solicitud').get('monto').value.replaceAll(',', '') > this.montoMaximo)) {
        this.naturalForm.get('solicitud').get('monto').setErrors({ incorrect: true });
        this.mensajeError = "Campo obligatorio. El monto máximo es de " + montoMaximo + " pesos.";
      }
      if(Number(this.naturalForm.get('solicitud').get('monto').value.replaceAll(',', '') < this.montoMinExpress)){
        this.naturalForm.get('solicitud').get('monto').setErrors({ incorrect: true });
        this.mensajeError = "Campo obligatorio. El monto mínimo es de " + montoMinimo + " pesos.";
      }
      if( auxMonto >= this.montoMinExpress && auxMonto <= this.montoMaxExpress
         && Number(this.naturalForm.get('solicitud.plazo').value) <= this.plazoMaxExpress){
        this.isExpress = true;
      }else{
        this.isExpress = false;
      }
      this.validarFlujoCaja(this.isExpress);
      if(this.isSeccionFlujoCaja){
        this.validarFlujoCaja(!this.isSeccionFlujoCaja);
      }
    }else{
      this.mensajeError = "Campo obligatorio";
    }
  }

  validarFechaRegistro(){
     var fecha3 = this.naturalForm.get('fechaRegistroActividadEconomica').value;
      var fechaRegistroMinima = new Date(fecha3);
      fechaRegistroMinima.setMonth(fechaRegistroMinima.getMonth()+this.fechaMinRegistro);
      var fechaRegistroMinimaString = fechaRegistroMinima.toLocaleDateString('en-CA');
    if(fechaRegistroMinimaString > this.fechaActual){
      this.naturalForm.get('fechaRegistroActividadEconomica').setErrors({ incorrect: true });
    }
    this.validarFechas('fechaRegistroActividadEconomica');
  }

  selectpikerChange(field: string) {
    $(`#${field}`).selectpicker('destroy');
    let valid = this.validateCampo(field);
    if (!valid) {
      $(`#${field}`).removeClass('is-invalid');
    } else {
      $(`#${field}`).addClass('is-invalid');
    }
    $(`#${field}`).addClass('selectpicker');
    $(`#${field}`).selectpicker('render');
  }

  validarFechas(campo: string) {
    let fechaIngresada = new Date();
    let fechaMinima = new Date();
    if (this.naturalForm.get(campo).value) {
      fechaIngresada = new Date(this.naturalForm.get(campo).value);
    }
    fechaMinima = new Date ("1900-01-01");
    if(fechaIngresada.getTime() < fechaMinima.getTime()) {
      this.naturalForm.controls[campo].setErrors({
        incorrect: true,
      });
    } else {
      this.naturalForm.controls[campo].setErrors(null);
    }
  }

  getCamposObligatorios():number{
    this.hasValidator = null;
    for (const field in this.naturalForm.controls) { 
      if (this.naturalForm.get(field).validator) {
        const validators = this.naturalForm.get(field).validator({} as any);
        if (validators && validators.required) {
          this.hasValidator++;
        }
      }
      if(field=='solicitud'){
        for (let field2 in this.naturalForm.get('solicitud')['controls']) {
          if(this.naturalForm.get('solicitud')['controls'][field2].validator != null){
            this.hasValidator++;
          }
        }
      }
    }
    return this.hasValidator;
  }

  getCamposLlenados():number{
    this.camposLlenados = null;
    for (const field in this.naturalForm.controls) {
      if (this.naturalForm.get(field).validator != null) {
        if (this.naturalForm.get(field).value !== null && this.naturalForm.get(field).value !== ""
          && ((this.naturalForm.get(field).value !== "0" && field != "seguridadSocial") ||
            this.naturalForm.get(field).value !== "" && field == "seguridadSocial")) {
            const validators = this.naturalForm.get(field).validator({} as any);
            if (validators && validators.required) {
              this.camposLlenados++;;
            }          
        }
      }
      if(field=='solicitud'){
        for (let field2 in this.naturalForm.get('solicitud')['controls']) {
          if(this.naturalForm.get('solicitud')['controls'][field2].validator != null){
            if(this.naturalForm.get('solicitud')['controls'][field2].value !== null &&
              this.naturalForm.get('solicitud')['controls'][field2].value !==  0 &&
              this.naturalForm.get('solicitud')['controls'][field2].value !== ""){
              this.camposLlenados++;
            }
          }
        }
      }
    }
    if(this.camposLlenados > this.getCamposObligatorios()){
      this.camposLlenados = this.getCamposObligatorios();
    }
    return this.camposLlenados;
  }

  calculoPorcentajeVertical(){
    if(this.getCamposLlenados() < this.getCamposObligatorios()){
      this.porcentajeVertical = Math.round((this.getCamposLlenados()/this.getCamposObligatorios())*100);
    } else {
      this.porcentajeVertical = 100;
    }
  }

  calcularTotalIngresos() {
    let totalIngresos = Number(this.naturalForm.get('flujoCajaVentas').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaOtrosIngresos').value.replace(/[,]/g, ''));
    this.naturalForm.get('totalIngresos').setValue(totalIngresos);
    this.calcularDineroDisponible();
  }

  calcularTotalGastos(){
    let totalGastos = Number(this.naturalForm.get('flujoCajaPagoProveedores').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaArriendo').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaAdministracion').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaServiciosPublicos').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaSueldoPropio').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaSueldoEmpleados').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaPlanCelular').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaTarjetaCredito').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaCuotaCreditos').value.replace(/[,]/g, ''))
     + Number(this.naturalForm.get('flujoCajaOtrosGastos').value.replace(/[,]/g, ''));
    this.naturalForm.get('totalGastos').setValue(totalGastos);
    this.calcularDineroDisponible();
  }

  calcularDineroDisponible(){
    let dineroDisponible = Number(this.naturalForm.get('totalIngresos').value.replace(/[,]/g, ''))
     - Number(this.naturalForm.get('totalGastos').value.replace(/[,]/g, ''));
    this.naturalForm.get('dineroDisponible').setValue(dineroDisponible);
  }
}